export const LOCAL_STORAGE_KEYS = {
  MENU: "menu-wide",
  MENU_LAST_VISITED: "menu-last-visited",
  RECENT_PROJECT: "most-recent-project",
  ADMIN_NOTIFICATION_FILTERS: "admin-notification-filters",
  LAST_USED_EMAIL: "last-used-email",
  PORTFOLIO_VIEW_MODE: "portfolio-view",
  TICKET_DESCENDING_ACTIVITIES: "ticket-descending-activities",
  USER_SELECTED_LANGUAGE: "language", // Currently selected language (in sync with BE)
  SUPPORTED_LANGUAGES: "languages", // Locally stored list of supported languages
  NEW_FEATURE: {
    AUTO_TRANSLATION_FEATURE: "has_see_auto_translation",
    AUTO_TRANSLATION_USER_LANGUAGE_SUPPORTED: "has_seen_user_language_supported",
    AUTO_TRANSLATION_CHAT_BANNER_DISMISSED: "has_dismissed_auto_translation_chat_banner",
  },
  PRODUCT_UPDATES_READ: (userId: string): string => `product-updates-read-${userId}`,
  TICKET_NOBI_SUGGESTION_DISMISSED: (ticketId: string): string => `ticket-${ticketId}-nobi-suggestion-dismissed`,
};
